import { createEnum } from '../helpers'

/**
 * Per-row error types for the SAP master-data imports (KNA1/KNB1/KNVP/VBAK).
 * `zodSchemaError` is raised when a row fails schema parsing; `missingKey` when a required key
 * column (e.g. the customer number) is blank after cleaning; `duplicateKey` when a row shares its
 * natural key with another row in the same file (ambiguous, so none are applied).
 */
export const SAP_IMPORT_ERRORS = ['zodSchemaError', 'missingKey', 'duplicateKey'] as const
export const SAP_IMPORT_ERROR_TYPES = createEnum(SAP_IMPORT_ERRORS)
export type SapImportErrorType = (typeof SAP_IMPORT_ERRORS)[number]
